import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {Box, Card, Grid} from '@primer/react-brand/esm'
import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'
import type {ImageLinkItem} from '../../types'
import {renderWithoutParagraphs} from '../../utils'

export type FlexSuiteIntroImageCardsProps = {
  cards?: ImageLinkItem[]
  promoteFirstHeading?: boolean
}

export function FlexSuiteIntroImageCards({cards, promoteFirstHeading = false}: FlexSuiteIntroImageCardsProps) {
  if (!cards?.length) return null

  const isTwoColumnLayout = cards.length === 2 || cards.length === 4
  const columnSpan = isTwoColumnLayout ? 6 : 4
  const imageMaxWidth = (MAX_CONTENT_WIDTH * columnSpan) / 12

  return (
    <Box marginBlockStart={48}>
      <Grid>
        {cards.map((card, index) => (
          <Grid.Column key={card.sys.id} span={{xsmall: 12, medium: 6, large: columnSpan}}>
            <Card href={card.fields.href} variant="minimal" fullWidth ctaText={card.fields.label}>
              <Card.Image
                src={`${card.fields.image.fields.file.url}?fm=webp`}
                alt={card.fields.image.fields.description || documentToPlainTextString(card.fields.heading) || ''}
                sources={getImageSources(card.fields.image.fields.file.url, {
                  maxWidth: imageMaxWidth,
                })}
              />
              <Card.Heading as={index === 0 && promoteFirstHeading ? 'h2' : 'h3'} size="6">
                {renderWithoutParagraphs(card.fields.heading)}
                {card.fields.alt ? <span className="sr-only"> {card.fields.alt}</span> : null}
              </Card.Heading>
              <Card.Description>{renderWithoutParagraphs(card.fields.description)}</Card.Description>
            </Card>
          </Grid.Column>
        ))}
      </Grid>
    </Box>
  )
}
